angular.module('zc.zenclerkS')
  .factory('Shopify', Shopify);

Shopify.$inject = ['Api'];
function Shopify(Api) {
  return {
    getLoginUrl,
  };

  function getLoginUrl(shop) {
    return Api.get(`/api/oauth/shopify/login_url?shop=${shop}`)
      .then(res => decodeURIComponent(res.data.login_url))
      .catch(error => console.error(error));
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/shopify.service.js